/** @prettier */

import {useEffect, useState} from 'react';

//API import
import {getStatesSitesSl} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';

import * as mySiteLib from '../../routes/my-site/mySiteLibrary';

/**
 * ユニット毎の消費電力量を画面読み込み時と、1分毎に取得するフック
 * @param siteId サイトID
 * @param timezone タイムゾーン
 * @returns ユニット毎の消費電力量データ
 */
export const useUnitPow = (siteId: string, timezone: string | undefined) => {
  /** ユニットデータ消費電力量データ */
  const [unitPwData, setUnitPwData] = useState<apiIF.resParameters.slStates[]>(
    []
  );

  /** APIで問い合わせる */
  const afterTime =
    timezone === undefined ? undefined : mySiteLib.timezone2aftertime(timezone);

  //消費電力取得用
  useEffect(() => {
    /** ユニット毎の消費電力を算出 */
    const reqStatesSitesPw = () => {
      //最新データ取得 (消費電力量取得)
      const query: apiIF.reqParameters.getStatesSitesSl = {
        'after-time': afterTime,
        'fields': 'power-consumption',
        'every-minute': 1440, //60min × 24h  １日分のデータ取得
      };

      getStatesSitesSl(siteId, query)
        .then(response => {
          //最新の稼働状況データ (配列の先頭が最新データ)
          setUnitPwData(response['sl-states'][0]['states']);
        })
        .catch(err => {});
    };

    //ページ遷移時初回読み込み
    reqStatesSitesPw();
    //定期実行
    const intervalId = setInterval(() => {
      reqStatesSitesPw();
    }, 60000);

    return function () {
      clearInterval(intervalId);
    };
  }, [siteId]);

  return {unitPwData};
};
